import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { ShapeshiftResultModel } from 'app/models/shapeshift.model';

@Injectable()
export class ShapeShiftService {
  private _url = 'https://shapeshift.io';
  private _publicApiKey: string;
  private _coins: any = null;

  constructor(private http: HttpClient) {}

  validateAddress(address: string, coin: string): Observable<any> {
    return this.get(['/validateAddress', address, coin].join('/'));
  }

  coinPairer(coin1?: string, coin2?: string): string {
    const pair: string = null;
    if ((coin1 === undefined && coin2 === undefined) || typeof coin1 === 'function') {
      return '';
    }
    if (coin2 === undefined || typeof coin2 === 'function') {
      return coin1.toLowerCase();
    }
    if (coin1 === undefined) {
      return pair;
    }
    return coin1.toLowerCase() + '_' + coin2.toLowerCase();
  }

  coins(): Observable<any> {
    if (this._coins) {
      return of(this._coins);
    }
    return this.get('/getcoins');
  }

  marketInfo(coinIn: string, coinOut: string) {
    return this.get(['/marketinfo', this.coinPairer(coinIn, coinOut)].join('/'));
  }

  get(endpoint: string) {
    return this.http.get(this._url + endpoint);
  }

  post(endpoint: string, body: any | null = null) {
    return this.http.post(this._url + endpoint, body);
  }

  fixedAmountTx(request: any): Observable<ShapeshiftResultModel> {
    const data = this.fixedAmountValidate(
      this.createFixedTx(request.amount, request.withdrawal, request.coinIn, request.coinOut, request.returnAddress)
    );
    return this.post('/sendamount', data).pipe(
      map((value: any) => {
        if (value && value.error) {
          throw new Error(value.error);
        }
        return value.success;
      })
    );
  }

  getStatusOfDepositToAddress(address: string) {
    return this.get(['/txStat', address].join('/'));
  }

  private createFixedTx(
    amount: number,
    withdrawalAddress: string,
    coinIn: string,
    coinOut: string,
    returnAddress?: string
  ) {
    const normalTx: { [key: string]: string | number } = {
      amount: amount,
      withdrawal: withdrawalAddress,
      pair: this.coinPairer(coinIn, coinOut),
    };
    if (returnAddress) {
      normalTx.returnAddress = returnAddress;
    }
    return normalTx;
  }

  private fixedAmountValidate(data: any): any {
    if (data.withdrawal === undefined) {
      throw new Error('No withdrawal address');
    }
    if (data.pair === undefined) {
      throw new Error('No pair given');
    }
    if (data.amount === undefined) {
      throw new Error('No amount given');
    }
    // if (data.returnAddress === undefined) {
    //   throw new Error('No return address given');
    // }
    data.apiPubKey = this._publicApiKey;
    return data;
  }

  public convertRate(to: string, from: string = 'edg') {
    return this.get(['/rate', from + '_' + to].join('/'));
  }

  public pairLimit(to: string, from: string = 'edg') {
    return this.get(['/limit', from + '_' + to].join('/'));
  }

  //
  // function FixedAmountValidate(data, ss) {
  //   if(data.withdrawal === undefined) throw new Error('no withdrawal address');
  //   if(data.pair === undefined) throw new Error('no pair given');
  //   if(data.amount === undefined) throw new Error('no amount given');
  //   if(data.returnAddress === undefined) throw new Error('no return address given');
  //   //TODO check if valid pair
  //   //TODO check if any other data in there is valid
  //
  //   data.apiPubKey = ss.apiPubKey;
  //   return data;
  // }

  //   var SSA=new ShapeShift.ShapeShiftApi();
  //   return {
  //   coins : function(){
  //     var promise = $q.defer();
  //     var coins = null;
  //     if(coins === null) {
  //       SSA.GetCoins(function (data) {
  //         coins = data;
  //         promise.resolve(coins);
  //       });
  //     } else {
  //       promise.resolve(coins);
  //     }
  //     return promise.promise;
  //   },
  //   marketInfo : function(coinIn, coinOut){
  //     var promise = $q.defer();
  //     SSA.GetMarketInfo(coinIn, coinOut, function (data) {
  //       promise.resolve(data)
  //     });
  //     return promise.promise;
  //   },
  //   FixedAmountTx : function($scope){
  //     var promise = $q.defer();
  //     $scope.ssError = null;
  //     var fixedTx = SSA.CreateFixedTx(
  //       $scope.amount, $scope.withdrawalAddress,
  //       $scope.coinIn, $scope.coinOut,
  //       $scope.returnAddress
  //     );
  //     SSA.FixedAmountTx(fixedTx, function (data) {
  //       return promise.resolve({ fixedTxData : data.success, error: data.error });
  //     });
  //     return promise.promise;
  //   },
  //   NormalTx : function($scope){
  //     var promise = $q.defer();
  //     var normalTx = SSA.CreateNormalTx($scope.withdrawalAddress, $scope.coinIn, $scope.coinOut);
  //     SSA.NormalTx(normalTx, function (data) {
  //       promise.resolve({ normalTxData : data });
  //     });
  //     return promise.promise;
  //   },
  //   CancelTx : function ($scope) {
  //     var promise = $q.defer();
  //     SSA.CancelPendingTx(
  //       { address:$scope.depositInfo.deposit },
  //       function(data){
  //         promise.resolve({ cancelTxData : data });
  //       });
  //     return promise.promise;
  //   },
  //   GetStatusOfDepositToAddress : function(address){
  //     var promise = $q.defer();
  //     SSA.GetStatusOfDepositToAddress(address, function(data){
  //       promise.resolve(data);
  //     });
  //     return promise.promise;
  //   },
  //   ValidateAddress : function(address, coin) {
  //     var promise = $q.defer();
  //     SSA.ValidateAdddress(address, coin, function(data){
  //       promise.resolve(data);
  //     });
  //     return promise.promise;
  //   }
  // };
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/account/shape-shift.service.ts